import React from "react";

const DetayLoader = () => {
  return (
    <div className="containerMain animate-pulse gap-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="left-area flex flex-col gap-8 w-full rounded-2xl">
          <div className="h-full w-full bg-gray-100 rounded-2xl mb-4"></div>
          <div className="h-full w-full bg-gray-100 rounded-2xl mb-2"></div>
          <div className="h-full w-full bg-gray-100 rounded-2xl mb-2"></div>
          <div className="h-full w-full bg-gray-100 rounded-2xl"></div>
        </div>
        <div className="right-area flex flex-col gap-8 w-full">
          <div className=" w-full bg-gray-100 rounded-2xl mb-4 h-[242px]"></div>

          <div className="bg-gray-100 rounded-2xl h-[214px] w-full"></div>

          <div className="w-full bg-gray-100 rounded-2xl my-4 h-[158px]"></div>
          <div className="w-full bg-gray-100 rounded-2xl my-4 h-[186]"></div>
          <div className=" w-full bg-gray-100 rounded-2xl h-[1000px]"></div>
        </div>
      </div>
    </div>
  );
};

export default DetayLoader;
